import { InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import type { ChatMessage } from '../Chat'
import { BaseChatMessageArgs } from './BaseChatMessageArgs'

@InputType()
export class AddCustomerChatReplyArgs extends BaseChatMessageArgs {}
export interface IAddCustomerChatReply extends IAction<ChatMessage, AddCustomerChatReplyArgs> {}
